export enum APIErrorType {
    InvalidParameters = "InvalidParametersError",
    InvalidSubscriptionError = "InvalidSubscriptionError",
    AlreadyExists = "ResourceAlreadyExists",
    InvalidGoogleToken = "InvalidGoogleToken",
    InvalidFacebookToken = "InvalidFacebookToken",
    InvalidLogin = "InvalidLoginError",
    ResourceNotFound = "ResourceNotFound",
    NotAccessibleError = "NotAccessibleError",
    UnknownError = "UnknownError",
    NetworkError = "NetworkError",
    MissingAuthorizationError = "MissingAuthorizationError",
    SessionNotFoundError = "SessionNotFoundError"
}

export type SubscriptionInfo = string;

export interface InvalidSubscriptionError {
    type: string;
    status: number;
    current_supscription: SubscriptionInfo;
    required_subscription: SubscriptionInfo;
    message: string;
}



// WEBPACK FOOTER //
// ./src/api/errors.ts